module.exports = __webpack_public_path__ + "img/Get-started-–-23.ebd77193.png";